import { StockMovementsModel } from '../../models/StockMovements';
import { MovementOrderCell, MovementTaskCell } from './MovementReference';

export function renderMovementOrder(data: StockMovementsModel): JSX.Element {
  return <MovementOrderCell item={data} />;
}

export function renderMovementTask(data: StockMovementsModel): JSX.Element {
  return <MovementTaskCell item={data} />;
}

/** Vista móvil: pedido, tarea (si aplica) y descripción */
export function renderMovementReferences(data: StockMovementsModel, options?: { showTask?: boolean }): JSX.Element {
  const description = data.description?.trim();
  const showTask = options?.showTask ?? true;

  return (
    <div className="flex flex-col gap-1 min-w-0">
      <MovementOrderCell item={data} />
      {showTask ? <MovementTaskCell item={data} /> : null}
      {description ? <span className="text-xs text-title line-clamp-2">{description}</span> : null}
    </div>
  );
}
